export enum GroupingSymbol {
    NONE = '',
    COMMA = ',',
    POINT = '.',
    SPACE = ' '
}
